module.exports = __webpack_public_path__ + "static/media/gileadLogo.b7d237a8.svg";